// excel导出列样式
const excelNumberFormats = {
	_int: '#,##0',
	_number: '#,##0.00',
	_float: '#,##0.00',
}

const getExcelStyle = (dataType, format) => {
	if (['_int', '_number', '_float'].includes(dataType)) {
		return { format: format || excelNumberFormats[dataType], alignment: { horizontal: 'Right' } }
	}
	if (dataType === '_date') return { format: format || 'Medium Date' }
	if (dataType === '_datetime') return { format: format || 'General Date' }
	return { format: format || 'General' }
}

// 转换导出列
// @param {Array} columns 列配置
// @param {String} type 导出类型，默认excel
// @return {Array} 导出列配置
const convertExportColumns = (columns, type = 'excel') => (columns || []).map(({ desc, width, dataType, format }) => ({
	text: Tyan.t(desc, 'columnText'),
	width: width || 100,
	style: getExcelStyle(dataType, format)
}))

export { convertExportColumns }
